import * as React from "react";

const CloseRounded: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM7.5 9L9 7.5L12 10.5858L15 7.5L16.5 9L13.4142 12L16.5 15L15 16.5L12 13.4142L9 16.5L7.5 15L10.5858 12L7.5 9Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(CloseRounded);
